// extracted by mini-css-extract-plugin
export default {"chart":"IMTGraph_chart__ZxCDr"};